import { useState } from "react";
import { useAuth } from "@/lib/auth";
import PageHeader from "@/components/PageHeader";
import {
  Lightbulb, LayoutDashboard, Rocket, Compass, CalendarRange, Network, Eye, Ghost,
} from "lucide-react";
import Cockpit from "@/components/BizDev/Cockpit";
import IdeasBoard from "@/components/BizDev/IdeasBoard";
import VenturesTab from "@/components/BizDev/VenturesTab";
import FrameworksTab from "@/components/BizDev/FrameworksTab";
import RoadmapTab from "@/components/BizDev/RoadmapTab";
import MindMapTab from "@/components/BizDev/MindMapTab";
import VisionBoardTab from "@/components/BizDev/VisionBoardTab";
import ResurrectionsTab from "@/components/BizDev/ResurrectionsTab";

/** Iter 169/170/171 · Business Development / Founder OS. */

const TABS = [
  { key: "cockpit", label: "Cockpit", Icon: LayoutDashboard },
  { key: "ideas", label: "Ideas", Icon: Lightbulb },
  { key: "roadmap", label: "Roadmap", Icon: CalendarRange },
  { key: "mindmap", label: "Mind Maps", Icon: Network },
  { key: "vision", label: "Vision Board", Icon: Eye },
  { key: "resurrections", label: "Resurrections", Icon: Ghost },
  { key: "ventures", label: "Ventures", Icon: Rocket },
  { key: "frameworks", label: "Frameworks & Tips", Icon: Compass },
];

export default function BizDev() {
  const { activeWorkspaceId: wsId } = useAuth();
  const [tab, setTab] = useState("cockpit");

  if (!wsId) return null;
  return (
    <div className="space-y-4" data-testid="bizdev-page">
      <PageHeader
        title="Business Development"
        subtitle="Your founder operating system — ideas, ventures, speculative revenue, and the frameworks to keep you honest."
      />
      <div className="flex items-center border-b border-border overflow-x-auto">
        {TABS.map(({ key, label, Icon }) => (
          <button key={key} type="button" onClick={() => setTab(key)}
            className={`px-3 py-2 text-xs font-medium flex items-center gap-1.5 whitespace-nowrap transition-colors border-b-2 ${tab === key ? "border-primary text-primary" : "border-transparent text-muted-foreground hover:text-foreground"}`}
            data-testid={`bizdev-tab-${key}`}>
            <Icon className="w-3.5 h-3.5" /> {label}
          </button>
        ))}
      </div>
      {tab === "cockpit" && <Cockpit wsId={wsId} onOpenIdeas={() => setTab("ideas")} onOpenResurrections={() => setTab("resurrections")} />}
      {tab === "ideas" && <IdeasBoard wsId={wsId} />}
      {tab === "roadmap" && <RoadmapTab wsId={wsId} />}
      {tab === "mindmap" && <MindMapTab wsId={wsId} />}
      {tab === "vision" && <VisionBoardTab wsId={wsId} />}
      {tab === "resurrections" && <ResurrectionsTab wsId={wsId} />}
      {tab === "ventures" && <VenturesTab wsId={wsId} />}
      {tab === "frameworks" && <FrameworksTab wsId={wsId} />}
    </div>
  );
}
